<template>
    <div class="yq-templates-simple-news-list" v-if="config&&data">
        <div class="yq-templates-simple-news-list-item" v-for="(row,index) in data" :key="row.id">
            <div class="yq-templates-simple-news-list-title" @click="showDetails(row.id)" :title="row.source[config.title.config.field]">
                <span style="padding-right: 5px;">{{(index+(pageNumber-1)*pageSize+1)}}</span>
                <img v-if="pageNumber===1&&index<3" src="../../assets/images/new.png" style="width: 32px;height: 14px;padding-right: 5px;">
                <span>{{row.source[config.title.config.field]}}</span>
            </div>
            <div class="yq-templates-simple-news-list-company"
                 :title="join(row.source[config.company.config.field])">
                {{join(row.source[config.company.config.field])}}
            </div>
            <div class="yq-templates-simple-news-list-site">来自:{{row.source[config.site.config.field]}}</div>
            <div class="yq-templates-simple-news-list-time">
                <pretty-date-time :value="row.source[config.publishDate.config.field]" format="uuuu-MM-dd"
                                  :value-format="publishDateField.dateValueFormat" java-format></pretty-date-time>
            </div>
        </div>
    </div>
</template>

<script>
    import preview from '../../assets/images/templates/news_list.png'
    import thumbnail from '../../assets/images/templates/news_list_thumbnail.png'
    import templateUtils from '../../service/view-template-utils'

    const regions = {
        title: {
            name: '标题',
            config: {
                field: {
                    name: '标题字段',
                    required: true,
                    type: 'field'
                }
            }
        },
        publishDate: {
            name: '发布时间',
            config: {
                field: {
                    name: '发布时间字段',
                    required: true,
                    type: 'field'
                }
            }
        },
        site: {
            name: '网站名称',
            config: {
                field: {
                    name: '网站名称字段',
                    required: true,
                    type: 'field'
                }
            }
        },
        company: {
            name: '公司名称',
            config: {
                field: {
                    name: '公司名称字段',
                    required: true,
                    type: 'field'
                }
            }
        },
    }
    export default {
        name: "CompanyNewsList",
        props: {
            config: Object,
            data: Array,
            datasource: Object,
            pageNumber: {
                type: Number,
                default: 1
            },
            pageSize: {
                type: Number,
                default: 10
            }
        },
        computed: {
            publishDateField () {
                return this.datasource.fields.find(field => field.name === this.config.publishDate.config.field)
            }
        },
        methods: {
            showDetails(id) {
                this.$emit('show-details', id)
            },
            join(value){
                if(!value){
                    return ''
                }else if(Array.isArray(value)){
                    return value.join('、')
                }else {
                    return value+''
                }
            }
        }
    }
    function getFields(config){
        const fields = []
        fields.push(config.title.config.field)
        fields.push(config.publishDate.config.field)
        fields.push(config.site.config.field)
        fields.push(config.company.config.field)
        return fields
    }
    function validateConfig(config){
        return templateUtils.validateConfig(regions, config)
    }
    export {regions, preview, thumbnail, getFields, validateConfig}
</script>

<style scoped>

</style>
